/**
 * 点検項目設定ページ用のスクリプト
 */
var daily_check_item_treemultiselect = null;

if (is_route('daily_check_item.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        daily_check_item_event_set();
        daily_check_item_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.daily_check_item_event_set = function() {

    $(document).on('sortstop',function () {
        // 番号を設定している要素に対しループ処理
        var d=[];
        var s=[];
        var num=0;
        $('table tr').each(function(i, e){
            var dd=[];
            var ss=[];
            if (i !== 0) {
                ss.push(String(num));
                $(this).find('td:eq(8)').each(function(j, el){ss.push($(this).text())});
                s.push(ss);
                
                $(this).find('td:eq(1)').each(function(j, el){dd.push($(this).text())});
                $(this).find('td:eq(8)').each(function(j, el){dd.push($(this).text())});
                d.push(dd);
            }
            num = ++num;
        });
        let action = "/daily_check_item/sort";
        let serial = s;
        let data = d;
        if ( JSON.stringify(serial) != JSON.stringify(data) ) {
            _ajax.post(action, {'data': data}, function (response) {
                // window.location.reload();
                _complete.set(response);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            }); 
        }
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
    });
    
    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id', 'type'], false, function() {
            daily_check_item_treemultiselect = initialize_treemultiselect();
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal=daily_check_item-detail-modal][data-id=' + results.daily_check_item.id + ']').trigger('click');
        }, function() {
            daily_check_item_set_steper_error();
        });
    });

    /*---- 一括有効クリック時 ----*/

    // 一括有効クリック時
    $(document).on('click', '#daily_check_item-all-enable-button', function () {
        let holding_id = $('#daily_check_item-list-holding_id').val();
        let company_id = $('#daily_check_item-list-company_id').val();
        _modal.create_with_data(this, 'enable-modal', {'holding_id': holding_id, 'company_id': company_id});
    });

    /*---- 一括有効処理 ----*/

    // 一括有効実行時
    $(document).on('click', '[data-all-enable-modal]', function () {
        _modal.submit(this, 'all-enable-modal', function(results) {
            _modal.hide('#daily_check_item-enable-modal');
            $("#daily_check_item-all-enable").trigger('change');
        });
    });

    /*---- 一括無効クリック時 ----*/

    // 一括無効クリック時
    $(document).on('click', '#daily_check_item-all-disable-button', function () {
        let holding_id = $('#daily_check_item-list-holding_id').val();
        let company_id = $('#daily_check_item-list-company_id').val();
        _modal.create_with_data(this, 'disable-modal', {'holding_id': holding_id, 'company_id': company_id});    
    });

    /*---- 一括無効処理 ----*/

    // 一括無効実行時
    $(document).on('click', '[data-all-disable-modal]', function () {
        _modal.submit(this, 'all-disable-modal', function(results) {
            _modal.hide('#daily_check_item-disable-modal');
            $("#daily_check_item-all-disable").trigger('change');
        });
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#daily_check_item-all-delete', function () {
        $(".daily_check_item-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.daily_check_item-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#daily_check_item-all-delete, .daily_check_item-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#daily_check_item-multi-delete-button').prop('disabled', ($('.daily_check_item-delete:checked').length == 0));
    });

    /*---- 除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.daily_check_item-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});    
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#daily_check_item-detail-modal');
        });
    });

}
/**
 * 設定モーダル表示時のイベント設定
 * @uses ダッシュボードからモーダル表示する際にも呼び出される
 */
window.daily_check_item_setting_event_set = function() {

    // 送信イベント変更時
    $(document).on('change', '#daily_check_item-setting-modal-send_events', function () {
        let value = $(this).val();
        if(value == 1){
            $('.setting-part').each(function() { 
                $(this).removeClass('display-none');
            });
        }else{
            $('.setting-part').each(function() { 
                $(this).addClass('display-none');
            });
            $('.setting-'+value).removeClass('display-none');
        }
    });
    
    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let formId = '#daily_check_item-setting-modal-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $('#daily_check_item-setting-modal-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        daily_check_item_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown);
            // ステップエラーを表示
            daily_check_item_set_steper_error();
        });
    });

    // 営業所変更時
    $(document).on('change', 'select.sections-select', function () {
        let companyId = $('#daily_check_item-setting-modal-company_id').val();
        let sectionIds = $(this).val();
        setTreeMultiSelect(this, 'select.users-select', {'company_id': companyId, 'section_ids': sectionIds});
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                daily_check_item_treemultiselect[0][0].remove();
                daily_check_item_treemultiselect[0][0].reload();
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.section_name
                    }).text(option.text));
                })
                daily_check_item_treemultiselect[0][0].reload();
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }
    function setDisplayOfValueInput(elm) {
        let input = $('input[id=daily_check_item-setting-modal-' + $(elm).data('target') + ']');
        if ($(input).attr('type') != 'hidden') {
            $(input).toggleClass('display-none', ($(elm).val() != '1'));
            if ($(input).val() == '') {
                $(input).val($(input).data('default'));
            }
            let suffix = $('#daily_check_item-setting-modal-' + $(elm).data('target') + '_suffix');
            $(suffix).toggleClass('display-none', ($(elm).val() != '1'));
        }
    }
    // switch
    $(document).off('change', '.daily_check_item_flag');
    $(document).on('change', '.daily_check_item_flag', function() {
        setDisplayOfValueInput(this);
    });
    $('.daily_check_item_flag:checked').each(function () {
        setDisplayOfValueInput(this);
    });

}

/**
 * ステッパーへのエラー表示処理
 * @param {*} showError 
 */
window.daily_check_item_set_steper_error = function (showError = true) {
    if (showError) {
        $('#part-trigger').toggleClass('error', ($('#part').find('.invalid-feedback:not(.copy)').length > 0));
    } else {
        $('#part-trigger').removeClass('error');
    }
}

/**
 * 会社を選択した時の処理を行う。
 */
$(function(){
    // 会社の選択時
    $(document).on('click', '.company-list .check-item', function() {
        // データの取得
        let id = $(this).parents('.company-list').data('company');
        let holding_id = $(this).parents('.company-list').data('holding');
        let action = $(this).parents('.company-list').data('action');
        let is_extend = $(this).parents('.company-list').data('is-extend');
        let excution = $(this).parents('.company-list').data('excution');
        let excutionData = (excution != null ? excution.split(',') : []);
        excutionData.push('page');
        // URLを作成
        action = _request.create_affiliation_url(action, is_extend, [{'name': 'holding_id', 'value': holding_id}, {'name': 'company_id', 'value': id}], excutionData);
        // リダイレクト
        location.href = action;
    });
});